import { html, LonaWebComponent } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";
import { DomUtils } from "@tento-ui/dom";
import { GESTURE_MANAGER } from "@tento-ui/gesture-manager";
import type { NavConfig } from "./blog-variant";

@component({ name: "std-nav-links-row" })
export class NavLinksRow extends LonaWebComponent {
  private linkRefs: Map<string, NavLinksRow.LinkRef> = new Map();
  private onNavigate: (href: string) => void = () => {};

  bind(nav: NavConfig): this {
    this.onNavigate = nav.onNavigate;
    const desiredChildren: HTMLElement[] = [];
    const desiredKeys = new Set<string>();

    for (let i = 0; i < nav.items.length; i++) {
      const item = nav.items[i];
      const key = `${i}:${item.label}`;
      desiredKeys.add(key);

      let ref = this.linkRefs.get(key);
      if (!ref) {
        const $link = document.createElement("a");
        $link.className = "brand-nav-link";
        $link.href = "#";
        $link.textContent = item.label;
        $link.assignStyles({
          cursor: "pointer",
        });

        ref = { $link, href: item.href ?? null };
        GESTURE_MANAGER.addPointerEvent($link, {
          onClick: () => {
            if (ref?.href != null) this.onNavigate(ref.href);
          },
        });
        this.linkRefs.set(key, ref);
      }

      ref.href = item.href ?? null;
      ref.$link.textContent = item.label;
      desiredChildren.push(ref.$link);
    }

    for (const [key] of this.linkRefs) {
      if (desiredKeys.has(key)) continue;
      this.linkRefs.delete(key);
    }

    DomUtils.reconcileChildren(this, desiredChildren);

    return this;
  }

  static $html: Option<HTMLTemplateElement> = html`<slot></slot>`;
  static $styles = [
    css`
      :host {
        display: flex;
        gap: 16px;
      }

      .brand-nav-link {
        text-decoration: none;
      }
    `,
  ];
}

export namespace NavLinksRow {
  export type LinkRef = {
    $link: HTMLElement;
    href: Option<string>;
  };
}
